function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import snakeCase from 'lodash.snakecase';
import { colors } from '@airwallex/global';
import { IconTick, IconSubtract } from '@airwallex/glyphs';
import { ReduxCheckboxGroup } from './redux/reduxCheckboxGroup';
import { ReduxCheckbox } from './redux/reduxCheckbox';
import CheckboxBox from './checkboxBox';
import HelpText from '../helpText';
import { CheckboxHolder, LabelHolder, AdditionalContainer, CheckboxInput } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      name = _ref.name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      checked = _ref.checked,
      value = _ref.value,
      help = _ref.help,
      className = _ref.className,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {
    form: '',
    touched: false,
    submitFailed: false
  } : _ref$meta,
      group = _ref.group,
      _ref$checkboxBackgrou = _ref.checkboxBackground,
      checkboxBackground = _ref$checkboxBackgrou === void 0 ? '' : _ref$checkboxBackgrou,
      _ref$checkboxBorder = _ref.checkboxBorder,
      checkboxBorder = _ref$checkboxBorder === void 0 ? '' : _ref$checkboxBorder,
      indeterminate = _ref.indeterminate,
      labelStyles = _ref.labelStyles,
      checkboxStyles = _ref.checkboxStyles,
      checkboxHolderStyles = _ref.checkboxHolderStyles,
      onChange = _ref.onChange,
      horizontal = _ref.horizontal,
      props = _objectWithoutProperties(_ref, ["label", "name", "disabled", "checked", "value", "help", "className", "meta", "group", "checkboxBackground", "checkboxBorder", "indeterminate", "labelStyles", "checkboxStyles", "checkboxHolderStyles", "onChange", "horizontal"]);

  var error = meta.error,
      warning = meta.warning,
      touched = meta.touched,
      submitFailed = meta.submitFailed;
  var id = "".concat(name, "_").concat(value);
  var hasError = !!error;
  var hasWarning = !!warning;
  var showError = (touched || submitFailed) && (hasError || hasWarning) && !group;
  return ___EmotionJSX(CheckboxHolder, {
    "data-test": snakeCase("".concat(meta.form, " ").concat(name, " ").concat(value)),
    className: className,
    css: checkboxHolderStyles,
    horizontal: horizontal
  }, ___EmotionJSX(CheckboxInput, _extends({
    css: checkboxStyles,
    name: name,
    id: id,
    checked: checked,
    value: value,
    disabled: disabled,
    hasError: showError,
    type: "checkbox",
    onChange: onChange
  }, props)), ___EmotionJSX(LabelHolder, {
    css: labelStyles,
    htmlFor: id,
    disabled: disabled,
    hasError: showError,
    background: checkboxBackground,
    border: checkboxBorder,
    horizontal: horizontal
  }, label, indeterminate ? ___EmotionJSX(IconSubtract, {
    size: 16,
    color: indeterminate && disabled ? colors.greys[40] : colors.white
  }) : ___EmotionJSX(IconTick, {
    size: 16,
    color: checked && disabled ? colors.greys[40] : colors.white
  })), ___EmotionJSX(AdditionalContainer, null, ___EmotionJSX(HelpText, {
    text: help
  }), showError && ___EmotionJSX(HelpText, {
    text: error || warning,
    isErrored: hasError,
    isWarning: hasWarning
  })));
};

export { Checkbox as default, CheckboxBox, ReduxCheckboxGroup, ReduxCheckbox };